export default __webpack_public_path__ + "static/media/mandate-sidebar.217ba3fe.svg";